const my = {
  meta: { code: "my", label: "မြန်မာ" },
  nav: {
    brand: "IQ Log",
    diagnostics: "အကဲဖြတ်မှု",
    mypage: "ကျွန်ုပ်၏စာမျက်နှာ",
    login: "ဝင်ရောက်",
    register: "မှတ်ပုံတင်",
    logout: "ထွက်ရန်",
  },
  hero: {
    eyebrow: "အကဲဖြတ်သည့်ပလက်ဖောင်း",
    title: "အကဲဖြတ်မှုများဖြင့် သင့်အနှစ်သာရကို ရှာဖွေပါ",
    subtitle1: "စဉ်းစားတွေးခေါ်မှု၊ ပင်ကိုယ်စရိုက်နှင့် စွမ်းရည် — အပြည့်အဝမြင်ယောင်",
    subtitle2: "၅ မိနစ်အတွင်း သင်၏ ခွန်အားနှင့် အားနည်းချက်ကို မြင်နိုင်",
    subtitle3: "အကဲဖြတ်မှုတိုင်း သင့်ဒေတာဖြစ်လာသည်",
    cta_primary: "အကဲဖြတ်မှုစတင်ရန်",
    cta_secondary: "ကတ်တလောက်ကြည့်ရန်",
    disclaimer: "ကိုးကားရန်အချက်အလက် / ဆေးဘက်ဆိုင်ရာမဟုတ်",
  },
  categories: {
    ability: "စွမ်းရည်",
    personality: "ပင်ကိုယ်စရိုက်",
    mental: "စိတ်ပိုင်း",
    aptitude: "သွေးခြည်း",
    traits: "သွင်ပြင်",
  },
  catalog: {
    title: "အကဲဖြတ်မှုအားလုံး",
    subtitle: "၁၇ စမ်းသပ်မှု / ၅ ခုအမျိုးအစား",
    filter_all: "အားလုံး",
    duration: "မိနစ်",
    difficulty: { easy: "လွယ်", medium: "အလယ်အလတ်", hard: "ခက်" },
    question_count: "မေးခွန်း",
    start: "စတင်",
  },
  quiz: {
    question: "မေးခွန်း",
    of: "/",
    next: "နောက်တစ်ခု",
    prev: "နောက်သို့",
    submit: "ရလဒ်ကြည့်ရန်",
    progress: "တိုးတက်မှု",
    exit: "ထွက်",
    required: "ရွေးချယ်စရာတစ်ခုကိုရွေးပါ",
    submitting: "အမှတ်ပေးနေသည်…",
  },
  result: {
    overall: "စုစုပေါင်းအမှတ်",
    type_label: "အမျိုးအစား",
    share_link: "လင့်ခ်ဖြင့်ရလဒ်မျှဝေရန်",
    back_to_catalog: "အခြားအကဲဖြတ်မှုလုပ်",
    view_mypage: "ကျွန်ုပ်စာမျက်နှာတွင် မှတ်တမ်းကြည့်",
    premium_title: "အသေးစိတ်ခွဲခြမ်းစိတ်ဖြာမှုဖွင့်",
    premium_subtitle: "ပရီမီယံဖြင့် အောက်ပါအားလုံးကိုမြင်နိုင်ပါမည်:",
    feature_breakdown: "အသေးစိတ်အမှတ်ခွဲခြမ်း",
    feature_cause: "အရင်းခံခွဲခြမ်းစိတ်ဖြာ",
    feature_plan: "တိုးတက်မှုအစီအစဉ်",
    feature_pdf: "PDF အစီရင်ခံစာ (A4)",
    price: "¥980",
    price_note: "(Stripe မှ လုံခြုံစွာငွေပေးချေခြင်း)",
    price_free: "အခမဲ့",
    price_free_note: "(ကန့်သတ်အချိန်ပိုင်း · ၁၀၀% အခမဲ့)",
    unlock_button: "Stripe ဖြင့်ငွေပေးချေ",
    unlock_button_free: "အခမဲ့ဖွင့်",
    unlock_requires_auth: "ဖွင့်ရန် ဝင်ရောက်ပါ",
    unlock_save_first: "အကောင့်ဖြင့် ရလဒ်ကိုဦးစွာသိမ်းပါ",
    unlocking: "Stripe သို့ ပြောင်းနေသည်…",
    free_only_notice: "အခမဲ့ဗားရှင်းသည် စုစုပေါင်းအမှတ်နှင့် အမျိုးအစားကိုသာပြသည်။",
    compliance_note:
      "ဤအကဲဖြတ်မှုသည် ကိုးကားရန်အချက်အလက်သာဖြစ်ပြီး ဆေးဘက်ဆိုင်ရာရောဂါ​ ​စစ်​ဆေးခြင်းမဟုတ်ပါ။ သေချာသည့်အသုံးအနှုန်း သို့မဟုတ် ကြောက်ရွံ့စေသည့်ဘာသာစကားကိုရှောင်ပါသည်။",
  },
  premium: {
    title: "အသေးစိတ်ခွဲခြမ်းစိတ်ဖြာမှုအစီရင်ခံစာ",
    summary: "ဘုံသီးခြားအနှစ်ချုပ်",
    strengths: "ခွန်အား",
    weaknesses: "ဖွံ့ဖြိုးတိုးတက်ရမည့်နယ်ပယ်",
    improvements: "တိုးတက်ရေးအစီအစဉ်",
    dimensions: "ဆိုင်းအမှတ်များ",
    download_pdf: "PDF ဒေါင်းလုဒ်",
    pdf_soon: "PDF ထုတ်ယူ (မကြာမီ)",
  },
  mypage: {
    title: "ကျွန်ုပ်၏စာမျက်နှာ",
    subtitle: "မှတ်တမ်း၊ အမှတ်လမ်းကြောင်းနှင့် ဆုတံဆိပ်များ",
    total: "စုစုပေါင်းအကဲဖြတ်မှု",
    average: "ပျမ်းမျှအမှတ်",
    premium_count: "ဖွင့်ပြီး",
    categories_covered: "ခုံအမျိုးအစားများ",
    trend_title: "အမှတ်လမ်းကြောင်း",
    history_title: "မှတ်တမ်း",
    badges_title: "ဆုတံဆိပ်များ",
    unlock_3_title: "ပေါင်းစပ်ခွဲခြမ်းစိတ်ဖြာမှုဖွင့်",
    unlock_3_desc: "ပေါင်းစပ်ခွဲခြမ်းစိတ်ဖြာမှုဖွင့်ရန် နောက်ထပ် {n} ခုလုပ်ပါ",
    unlocked: "ပေါင်းစပ်ခွဲခြမ်းစိတ်ဖြာမှု ဖွင့်ပြီး",
    no_history: "မရှိသေး — ပထမဆုံးအကဲဖြတ်မှုစတင်ပါ။",
  },
  auth: {
    login_title: "ဝင်ရောက်",
    register_title: "အကောင့်ဖန်တီး",
    email: "အီးမေးလ်",
    password: "စကားဝှက် (အနည်းဆုံး ၆ လုံး)",
    name: "ပြသနာမည် (ရွေးချယ်ခွင့်)",
    login_btn: "ဝင်ရောက်",
    register_btn: "မှတ်ပုံတင်",
    go_register: "အကောင့်မရှိ? မှတ်ပုံတင်",
    go_login: "အကောင့်ရှိပြီ? ဝင်ရောက်",
    anon_note: "အကဲဖြတ်မှုများသည် အခမဲ့နှင့်အမည်ဝှက်ဖြစ်သည်။ ရလဒ်သိမ်းရန်နှင့် ပရီမီယံဖွင့်ရန်အတွက်သာ အကောင့်လိုအပ်သည်။",
    success_register: "အကောင့်ဖန်တီးပြီး",
    success_login: "ဝင်ရောက်ပြီး",
    consent_section: "သဘောတူညီချက်",
    consent_required: "မဖြစ်မနေအချက်များကိုလက်ခံပါ",
    accept_terms_pre: "ကျွန်ုပ်သဘောတူ",
    terms_link: "ဝန်ဆောင်မှုစည်းကမ်းချက်များ",
    accept_terms_post: "",
    accept_privacy_pre: "ကျွန်ုပ်ဖတ်ပြီးပြီ",
    privacy_link: "ကိုယ်ရေးကိုယ်တာမူဝါဒ",
    accept_privacy_post: "ပြီး ကျွန်ုပ်၏ကိုယ်ရေးအချက်အလက်ကိုအသုံးပြုခွင့်ပြုသည်",
    accept_age: "ကျွန်ုပ်သည် အသက် ၁၆ နှစ်နှင့်အထက် (သို့) တရားဝင်အုပ်ထိန်းသူ၏ခွင့်ပြုချက်ရှိသည်",
    accept_marketing: "အကဲဖြတ်မှုအသစ်များနှင့်ပရိုမိုးရှင်းကြောင်းအီးမေးလ်ပို့ပါ",
    optional: "ရွေးချယ်ခွင့်",
  },
  landing: {
    status_online: "စနစ်အွန်လိုင်း",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "၁၇ စမ်းသပ်မှု",
    status_langs: "၁၄ ဘာသာ",
    status_ai: "AI · ဖွင့်",
    title_line1: "သင့်အနှစ်သာရကို",
    title_line2: "၅ မိနစ်အတွင်း ရှာဖွေပါ။",
    trust_diagnostics: "အကဲဖြတ်မှု",
    trust_languages: "ဘာသာစကား",
    trust_per_test: "တစ်ခုလျှင်",
    hud_readout: "အဓိကဖတ်ရှုမှု",
    hud_score_unit: "/100 စုစုပေါင်း",
    hud_band: "အဆင့် · GOLD",
    hud_dimensions: "ဆိုင်းများ",
    hud_dimensions_status: "၃ / ၃ အသက်ဝင်",
    hud_syslog: "စနစ်မှတ်တမ်း",
    cat_eyebrow: "// အမျိုးအစား",
    cat_title_pre: "၅ အမျိုးအစား · ",
    cat_title_highlight: "၁၇ အကဲဖြတ်မှု",
    view_all: "အားလုံးကြည့်",
    proto_eyebrow: "// လုပ်ထုံး",
    proto_title_pre: "၃ ခုခြင်းဖြင့် ",
    proto_title_highlight: "အနှစ်သာရကိုဖွင့်",
    step1_title: "စမ်းသပ်မှုတစ်ခုရွေး",
    step1_body: "၁၇ ခုထဲမှရွေးချယ်။ အမည်မဖော်စတင်",
    step2_title: "၅ မိနစ်ဖြေဆိုပါ",
    step2_body: "တိုးတက်မှုဘား + ဆုတံဆိပ်များဖြင့်အားပေး",
    step3_title: "AI ဖြင့်ဖွင့်",
    step3_body: "အသေးစိတ်အမှတ်၊ အစီအစဉ်နှင့် PDF",
    final_eyebrow: "// အသင့်ပြီးပြီလား?",
    final_title_pre: "သင့်အနှစ်သာရ ",
    final_title_highlight: "၅ မိနစ်အတွင်း",
    final_subtitle: "၅ မိနစ်အတွင်း သင်၏ ခွန်အားနှင့် အားနည်းချက်",
    final_button: "ယခုပင်စတင်",
  },
  footer: {
    tagline: "သင့်စဉ်းစားတွေးခေါ်မှု၊ ပင်ကိုယ်စရိုက်နှင့်စွမ်းရည်ကိုအကဲဖြတ်သည့်ပလက်ဖောင်း",
    rights: "မူပိုင်ခွင့်အားလုံးကိုထိန်းသိမ်းထားသည်။",
    legal: "ဥပဒေ",
    privacy: "ကိုယ်ရေးအချက်",
    terms: "စည်းကမ်း",
    about_label: "အကြောင်း / ကုမ္ပဏီ",
    compliance_label: "နိုင်ငံတကာစံချိန်",
    tokushoho_label: "ဂျပန်ကုန်သွယ်မှုဥပဒေ",
    data_protection_label: "ဒေတာကာကွယ်မှု (နိုင်ငံတကာ)",
    data_request_label: "ဒေတာဖျက် / ငြင်းဆန်",
    disclaimer_label: "ငြင်းဆိုချက်",
    disclaimer_full:
      "ဤဝန်ဆောင်မှုသည် ကိုးကားရန်သာဖြစ်ပြီး ဆေးဘက်ဆိုင်ရာရောဂါ​ ​စစ်​ဆေးခြင်းမဟုတ်ပါ။ ကျွန်ုပ်တို့သည် သေချာသည့်အသုံးအနှုန်း သို့မဟုတ် ကြောက်ရွံ့စေသည့်ဘာသာစကားကိုမသုံးပါ။",
  },
  badges: {
    "first-diagnosis": "ပထမဆုံးအကဲဖြတ်မှု",
    "three-diagnostics": "၃ ခုအောင်မြင်",
    "five-diagnostics": "၅ ခုအောင်မြင်",
    "ten-diagnostics": "၁၀ ခုအောင်မြင်",
    "high-performer": "မြင့်မားသောစွမ်းဆောင်ရည်",
    "premium-user": "ပရီမီယံအသုံးပြုသူ",
  },
  lang_selector: "ဘာသာစကား",
  payment: {
    processing_title: "ငွေပေးချေမှုစစ်ဆေးနေသည်…",
    processing_subtitle: "Stripe မှပြန်ရောက်လာ — အသေးစိတ်ခွဲခြမ်းစိတ်ဖြာမှုဖန်တီးနေသည် (၂၀ စက္ကန့်ထိ)",
    success: "ငွေပေးချေမှုအတည်ပြုပြီး — ပရီမီယံဖွင့်ပြီး",
    expired: "ငွေပေးချေမှုစက်ရှင်သက်တမ်းကုန်ပါပြီ။ ထပ်မံကြိုးစားပါ။",
    error: "ငွေပေးချေမှုကိုစစ်ဆေး၍မရပါ။ ပံ့ပိုးကူညီမှုကိုဆက်သွယ်ပါ။",
  },
};
export default my;
